import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/user/user3.jpg'
import _imports_1 from '../../../assets/images/user/user1.jpg'
import _imports_2 from '../../../assets/images/user/user4.jpg'
import _imports_3 from '../../../assets/images/user/user6.jpg'
import _imports_4 from '../../../assets/images/user/user7.jpg'
import _imports_5 from '../../../assets/images/user/user2.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-9" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing ticket-grid-box" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "item transition" }
const _hoisted_6 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "d-sm-flex" }
const _hoisted_8 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_9 = { class: "d-sm-flex mb-8" }
const _hoisted_10 = { class: "item transition" }
const _hoisted_11 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "d-sm-flex" }
const _hoisted_13 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_14 = { class: "d-sm-flex mb-8" }
const _hoisted_15 = { class: "item transition" }
const _hoisted_16 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_17 = { class: "d-sm-flex" }
const _hoisted_18 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_19 = { class: "d-sm-flex mb-8" }
const _hoisted_20 = { class: "item transition" }
const _hoisted_21 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_22 = { class: "d-sm-flex" }
const _hoisted_23 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_24 = { class: "d-sm-flex mb-8" }
const _hoisted_25 = { class: "item transition" }
const _hoisted_26 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_27 = { class: "d-sm-flex" }
const _hoisted_28 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_29 = { class: "d-sm-flex mb-8" }
const _hoisted_30 = { class: "item transition" }
const _hoisted_31 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_32 = { class: "d-sm-flex" }
const _hoisted_33 = { class: "mt-10 mt-sm-0 ms-sm-8" }
const _hoisted_34 = { class: "d-sm-flex mb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[32] || (_cache[32] = _createStaticVNode("<div class=\"col-lg-3\"><div class=\"card mb-25 border-0 rounded-0 bg-white letter-spacing contact-information-card\"><div class=\"card-head\"><h5 class=\"card-title lh-1 fw-semibold mb-0 text-muted\">Filters</h5></div><div class=\"card-body\"><form><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\"> Priority </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Urgent</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Source</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Instagram</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Status</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Recent</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Group</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Billing</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group mb-15 mb-md-20\"><label class=\"d-block text-black fw-semibold mb-10\">Agent</label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Jonathon Ronan</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div><div class=\"form-group\"><label class=\"d-block text-black fw-semibold mb-10\"> Category </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>None</option><option value=\"1\">2</option><option value=\"2\">3</option><option value=\"3\">4</option></select></div></form></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25\"><form class=\"search-box position-relative\"><input type=\"text\" class=\"form-control shadow-none text-black rounded-0 border-0\" placeholder=\"Search ticket\"><button type=\"submit\" class=\"bg-transparent text-primary transition p-0 border-0\"><i class=\"flaticon-search-interface-symbol\"></i></button></form><div class=\"d-sm-flex align-items-center\"><a href=\"javascript:void(0);\" class=\"default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mt-10 mt-md-0 text-decoration-none\"> Add New Ticket <i class=\"flaticon-plus position-relative ms-5 fs-12\"></i></a><button class=\"default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0\" type=\"button\"> Export <i class=\"flaticon-file-1 position-relative ms-5 top-2 fs-15\"></i></button></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "form-check mb-0" }, [
                  _createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-preview",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" Adlash Dashboard Design #Ticket 1436 ", -1)
                      ])),
                      _: 1,
                      __: [0]
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "badge text-outline-success mt-10 mt-sm-0 ms-sm-10" }, "Recent", -1))
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded-circle me-8",
                      width: "24",
                      height: "24",
                      alt: "user"
                    }),
                    _createTextVNode(" Jacky Ronan "),
                    _createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "2 days ago")
                  ], -1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-danger me-15 me-sm-20 me-md-25 me-lg-30\">Urgent</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option selected>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "form-check mb-0" }, [
                  _createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" Higher Calculus App Design #Ticket 2098 ", -1)
                      ])),
                      _: 1,
                      __: [5]
                    }),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "badge text-outline-danger mt-10 mt-sm-0 ms-sm-10" }, "Overdue", -1))
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "rounded-circle me-8",
                      width: "24",
                      height: "24",
                      alt: "user"
                    }),
                    _createTextVNode(" Victor James "),
                    _createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "3 days ago")
                  ], -1))
                ])
              ]),
              _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-primary me-15 me-sm-20 me-md-25 me-lg-30\">High</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\" selected>Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "form-check mb-0" }, [
                  _createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode(" Adlash Admin Issue #Ticket 3465 ", -1)
                      ])),
                      _: 1,
                      __: [10]
                    }),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "badge text-outline-info mt-10 mt-sm-0 ms-sm-10" }, " Remaining ", -1))
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "rounded-circle me-8",
                      width: "24",
                      height: "24",
                      alt: "user"
                    }),
                    _createTextVNode(" Angela Carter "),
                    _createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "4 days ago")
                  ], -1))
                ])
              ]),
              _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-info me-15 me-sm-20 me-md-25 me-lg-30\">Medium</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\" selected>C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "form-check mb-0" }, [
                  _createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode(" Email Submission Issue #Ticket 2345 ", -1)
                      ])),
                      _: 1,
                      __: [15]
                    }),
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "badge text-outline-primary mt-10 mt-sm-0 ms-sm-10" }, "Responded", -1))
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "rounded-circle me-8",
                      width: "24",
                      height: "24",
                      alt: "user"
                    }),
                    _createTextVNode(" Bretlon White "),
                    _createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "2 days ago")
                  ], -1))
                ])
              ]),
              _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-danger me-15 me-sm-20 me-md-25 me-lg-30\">Urgent</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\" selected>A. Smith</option></select></div>", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "form-check mb-0" }, [
                  _createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode(" Adlash Dashboard Design #Ticket 1436 ", -1)
                      ])),
                      _: 1,
                      __: [20]
                    }),
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "badge text-outline-muted mt-10 mt-sm-0 ms-sm-10" }, "Closed", -1))
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "rounded-circle me-8",
                      width: "24",
                      height: "24",
                      alt: "user"
                    }),
                    _createTextVNode(" Sam Smith "),
                    _createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "3 days ago")
                  ], -1))
                ])
              ]),
              _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-warning me-15 me-sm-20 me-md-25 me-lg-30\">Low</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option selected>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\">A. Smith</option></select></div>", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "form-check mb-0" }, [
                  _createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_router_link, {
                      to: "/ticket-previewl",
                      class: "d-block text-decoration-none fw-medium fs-md-16 fs-lg-16"
                    }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode(" Email Submission Issue #Ticket 2345 ", -1)
                      ])),
                      _: 1,
                      __: [25]
                    }),
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "badge text-outline-success mt-10 mt-sm-0 ms-sm-10" }, " Recent ", -1))
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-circle me-8",
                      width: "24",
                      height: "24",
                      alt: "user"
                    }),
                    _createTextVNode(" Victoria Carter "),
                    _createElementVNode("span", { class: "fs-12 text-muted fw-medium ms-8" }, "3 days ago")
                  ], -1))
                ])
              ]),
              _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"d-flex align-items-center mt-10 mt-md-0\"><span class=\"lh-1 fw-medium text-danger me-15 me-sm-20 me-md-25 me-lg-30\">Urgent</span><select class=\"form-select shadow-none rounded-0 fs-md-15 fs-lg-16 fw-medium\"><option>J. Linowiski</option><option value=\"1\">Z. White</option><option value=\"2\">C. Benden</option><option value=\"3\" selected>A. Smith</option></select></div>", 1))
            ])
          ]),
          _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center\"><p class=\"mb-0 text-paragraph\"> Showing <span class=\"fw-bold\">06</span> out of <span class=\"fw-bold\">13</span> results </p><nav class=\"mt-15 mt-md-0\"><ul class=\"pagination mb-0\"><li class=\"page-item\"><a class=\"page-link\" href=\"#\" aria-label=\"Previous\"><i class=\"flaticon-chevron-1\"></i></a></li><li class=\"page-item\"><a class=\"page-link active\" href=\"#\">1</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\" aria-label=\"Next\"><i class=\"flaticon-chevron\"></i></a></li></ul></nav></div>", 1))
        ])
      ])
    ])
  ]))
}